import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useLocation} from 'react-router-dom';
import {useUserSessionContext} from '../../core/UserSessionContext';
import {useRegFormsContext} from '../../../../modules/RegForms/components/RegFormsContext';
import NavItem from '../NavItem';
import PopupRedirectToForm101 from '../PopupRedirectToForm101';
import {pathnames as P} from '../../../enums/pathnames';
import styles from './NavBar.module.scss';

export type NavItemOption = {
  link: string
  label: React.ReactNode
  className?: string
  onClick?: () => void | Promise<void>
}

const NavBar = () => {
  const {handleLogout, paymentPageNotAllowed, invoiceOrderPageNotAllowed} = useUserSessionContext();
  const {form101FileStatus, status} = useRegFormsContext();
  const isForm101Filled = form101FileStatus.exists;
  const location = useLocation();
  const hideNavBarLocations = [
    P.AUTH,
    P.LOGOUT,
    P.LOGIN,
    P.LOGIN_BY_PHONE,
    P.LOGIN_AS_ADMIN,
    P.FORGOT_PASSWORD,
    P.UPDATE_PASSWORD,
    P.REGISTER
  ];
  const hideNavBar = hideNavBarLocations.includes(location.pathname) || location.pathname.includes('/paypalPaymentStatus');

  const navItems: NavItemOption[] = [
    {
      label: (
        <FormattedMessage
          id={'link-dashboard'}
          defaultMessage={'Dashboard'}
        />
      ),
      link: P.HOME,
      className: styles.firstNavItem
    },
    {
      label: (
        <FormattedMessage
          id={'link-invoices'}
          defaultMessage={'Invoices'}
        />
      ),
      link: P.INVOICES,
    },
    {
      label: (
        <FormattedMessage
          id={'link-receipts'}
          defaultMessage={'Receipts'}
        />
      ),
      link: P.RECEIPTS
    },
    {
      label: (
        <FormattedMessage
          id={'link-orderInvoice'}
          defaultMessage={'Order Invoice'}
        />
      ),
      link: P.ORDER_INVOICE,
    },
    {
      label: (
        <FormattedMessage
          id={'link-invoiceOrders'}
          defaultMessage={'Invoice Orders'}
        />
      ),
      link: P.INVOICE_ORDERS
    },
    {
      label: (
        <FormattedMessage
          id={'link-transfers'}
          defaultMessage={'Transfers'}
        />
      ),
      link: P.TRANSFERS
    },
    {
      label: (
        <FormattedMessage
          id={'link-payment'}
          defaultMessage={'Payment'}
        />
      ),
      link: P.PAYMENT,
    },
    {
      label: (
        <FormattedMessage
          id={'link-inviteFriend'}
          defaultMessage={'Invite friend'}
        />
      ),
      link: P.INVITE_FRIEND,
      className: styles.noBorder
    },
    {
      label: (
        <FormattedMessage
          id={'link-regForms'}
          defaultMessage={'Registration forms'}
        />
      ),
      link: P.REG_FORMS,
      className: styles.noBorder
    },
    {
      label: (
        <FormattedMessage
          id={'link-settings'}
          defaultMessage={'Settings'}
        />
      ),
      link: P.SETTINGS,
      className: styles.noBorder
    },
    {
      label: (
        <FormattedMessage
          id={'link-logout'}
          defaultMessage={'Logout'}
        />
      ),
      link: P.LOGOUT,
      className: styles.noBorder,
      onClick: () => handleLogout()
    }
  ];

  const filteredNavItems = navItems.filter(item => {
    if (paymentPageNotAllowed && item.link === P.PAYMENT) {
      return false;
    }

    if (invoiceOrderPageNotAllowed && item.link === P.ORDER_INVOICE) {
      return false;
    }

    return true;
  });

  const getNavItems = () => filteredNavItems.map((item, index) => {
    return item.link === P.ORDER_INVOICE && !isForm101Filled
      ? <PopupRedirectToForm101 {...item} type={'link'} key={index} redirectLink={status.form101.link}/>
      : <NavItem {...item} key={index}/>;
  });

  return !hideNavBar
    ? <div data-testid={'navbar'} className={styles.navBarContainer}>{getNavItems()}</div>
    : null;
};

export default NavBar;